import { QueryParamsModel } from '../../_base/crud';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Condition } from '../_models/condition.model';
import { ConditionActions, ConditionActionTypes } from '../_actions/condition.actions';

export interface ConditionsState extends EntityState<Condition> {
  entityId: number;
  loading: boolean;
  actionsloading: boolean;
  totalCount: number;
  lastCreatedContactRelationshipId: number;
  lastQuery: QueryParamsModel;
  showInitWaitingMessage: boolean;
  error: any | null;
}

export function selectConditionId(condition: Condition): number {
  return condition.id;
}
export const adapter: EntityAdapter<Condition> = createEntityAdapter<Condition>({
  selectId: selectConditionId,
});

export const initialConditionsState: ConditionsState = adapter.getInitialState({
  loading: false,
  actionsloading: false,
  totalCount: 0,
  entityId: undefined,
  lastCreatedContactRelationshipId: undefined,
  lastQuery: new QueryParamsModel({}),
  showInitWaitingMessage: true,
  error: null,
});

export function ConditionsReducer(
  state = initialConditionsState,
  action: ConditionActions,
): ConditionsState {
  switch (action.type) {
    case ConditionActionTypes.ThrowConditionError: {
      return {
        ...state,
        error: action.payload.error,
        actionsloading: false,
        loading: false,
      };
    }
    case ConditionActionTypes.ConditionUpdated:
      return adapter.updateOne(action.payload.condition, state);
    case ConditionActionTypes.ConditionPageToggleLoading:
      return {
        ...state,
        loading: action.payload.isLoading,
        lastCreatedContactRelationshipId: undefined,
      };
    case ConditionActionTypes.ConditionPageRequested:
      return {
        ...state,
        totalCount: 0,
        loading: true,
        showInitWaitingMessage: true,
        entityId: action.payload.entityId,
        lastQuery: action.payload.page,
      };
    case ConditionActionTypes.ConditionPageLoaded:
      return adapter.addMany(action.payload.conditions, {
        ...initialConditionsState,
        totalCount: action.payload.totalCount,
        loading: false,
        entityId: state.entityId,
        lastQuery: state.lastQuery,
        showInitWaitingMessage: false,
      });
    case ConditionActionTypes.ConditionOnServerCreated:
      return { ...state, loading: true };
    case ConditionActionTypes.ClearConditionErrors: {
      return {
        ...state,
        error: null,
      };
    }
    case ConditionActionTypes.ConditionCreated:
      return adapter.addOne(action.payload.condition, {
        ...state,
        lastCreatedContactRelationshipId: action.payload.condition.id,
      });
    case ConditionActionTypes.ConditionActionToggleLoading: {
      return {
        ...state,
        actionsloading: action.payload.isLoading,
      };
    }
    default:
      return state;
  }
}
export const { selectAll, selectEntities, selectIds, selectTotal } = adapter.getSelectors();
